import { render, staticRenderFns } from "./TipoMandatoNew.vue?vue&type=template&id=20250a78&scoped=true&"
import script from "./TipoMandatoNew.vue?vue&type=script&lang=js&"
export * from "./TipoMandatoNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20250a78",
  null
  
)

export default component.exports